<template>
    <section class="row card header-unidade">
        <div class="card-body display-space-between ">
            <div class="display-flex">
                <p style="font-size: 14pt; margin-bottom: 0; color: #000000;font-weight: bold; text-transform: uppercase; margin-left: 12px;">{{ unidade.nome }}</p>
                <div style="display: flex !important;">
                    <p 
                    style="font-size: 8pt; color: black; text-transform: uppercase; margin-left: 12px; margin-right: 3px; margin-bottom: 0;"
                    >
                    Status da comunicação:
                    </p>
                    <p
                    :style="{ color: unidadeStatus === 'SUCESSO' ? '#4CAF50' : 'red' }"	
                    style="
                        text-transform: uppercase;
                        font-size: 8pt;
                        margin-bottom: 0;
                        display: inline-block;
                        "
                    >
                    {{ (unidadeStatus ? unidadeStatus : 'FALHA') }}
                    </p>
                </div>
            </div>
            <h5 style=" margin-right: 12px; margin-bottom: 0; display: flex; align-items: center;">{{ vue_app_name }} v{{ version }}</h5>
        </div>
    </section>
</template>
<script>
import { ref, watch, nextTick } from 'vue';
import { useStore } from 'vuex';

export default {
    setup () {
        const vue_app_name = process.env.VUE_APP_NAME;
        const version = process.env.VUE_APP_VERSION;
        const store = useStore();
        const unidade = ref({});
        const unidadeStatus = ref('');

        const getStatus = async () => {
            try{
                const response = await store.dispatch('unidade/getServicoStatus', unidade.value.id)
                if (response.data.consumers == 0 || response.data.messages > 1) {
                    unidadeStatus.value = 'FALHA'
                } else {
                    unidadeStatus.value = 'SUCESSO'
                }
            } catch (error) {
                console.error('Erro ao obter status do serviço:', error);
            }
        };

        watch(() => store.state.unidade.unidade, async (newUnidade) => {
				unidade.value = newUnidade;
                await nextTick();
                getStatus();
			}, { immediate: true }
		);

        return {
            vue_app_name,
            version,
            unidade,
            unidadeStatus
        }
    }
}
</script>
<style scoped>
.display-space-between {
    display: flex;
    justify-content: space-between;
    box-shadow: 0px 8px 20px 0px #d5c0c0;
    background-color: #ffffff !important;
}
</style>